import React from 'react'
import { Link } from 'gatsby';
import SEO from '../components/SEO';
import Summary from '../components/summary';
import Layout from '../components/layout'

const IndexPage = ({data}) => {
  return (
    <Layout>
      <SEO/>
      <h3>議会での活動実績</h3>
      <Summary/>
      <p>公開されているデータをもとに、柏市政、議会、議員の動きを見えるようにしています。</p>
      <p>情報に間違いがある場合は
        <a rel='noopener noreferrer' href='https://docs.google.com/forms/d/e/1FAIpQLSfbzcVqw5-86DbkgJsXs2v_H3XbNVTxQooFBUarkrwhRN2Vxg/viewform' target='_blank'>問い合わせフォーム</a>
        からご報告ください。
      </p>
      <ul>
        <li><Link to='/giins'>議員紹介</Link></li>
        <li><Link to='/groups'>会派紹介</Link></li>
        <li><Link to='/tfidf'>議会で話題になっていること</Link></li>
      </ul>
    </Layout>
  );
};

export default IndexPage;
